module.exports = __webpack_public_path__ + "img/horizontal_6_4_9006.3cf9b3a9.png";